import { CommonModule } from '@angular/common';
import {
  AfterContentInit,
  Component,
  EventEmitter,
  Input,
  Output,
  ViewEncapsulation
} from '@angular/core';

import { TooltipDirective } from '@com-delta-omnichannel/aura';
import { TooltipInfo, TrackerFooter } from '../models/skyclub.interfaces';

@Component({
  selector: 'idp-skyclub-spend-tracker-footer',
  standalone: true,
  imports: [CommonModule, TooltipDirective],
  templateUrl: './skyclub-spend-tracker-footer.component.html',
  styleUrls: ['./skyclub-spend-tracker-footer.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class SkyclubSpendTrackerFooterComponent implements AfterContentInit {
  @Input() content: TrackerFooter | TooltipInfo = {} as TrackerFooter;

  @Output() searchEligibleClick = new EventEmitter<string>();

  constructor() {
    // Constructor intentionally empty
  }

  maxSpend = 75;
  spendProgress = 0;
  remainingSpend = 75;

  ngAfterContentInit() {
    if (this.isTrackerFooter) {
      this.getValuesfromContent();
    }
  }

  get isTrackerFooter(): boolean {
    return 'total' in this.content;
  }

  get trackerContent(): TrackerFooter {
    return this.content as TrackerFooter;
  }

  get tooltipContent(): TooltipInfo {
    return this.content as TooltipInfo;
  }

  get progressPercentage(): number {
    const percentage = (this.spendProgress / 75000) * 100;
    return Math.min(percentage, 100); // Cap at 100%
  }

  get isThresholdMet(): boolean {
    return this.spendProgress >= 75000;
  }

  // This is a temporary function made for component mock data
  // This component should acquire data from a selector once API creation is completed
  getValuesfromContent() {
    const tracker = this.content as TrackerFooter;
    this.maxSpend = this.extractNumber(tracker.max);
    this.spendProgress = this.extractNumber(tracker.total.title);
    this.remainingSpend = this.extractNumber(tracker.spendLink.label);
  }

  // Extracts number from string, handling commas and currency symbols
  // returns the extracted number or 0 if no number is found
  extractNumber(str: string): number {
    const cleanStr = str.replace(/[^\d]/g, '');
    return cleanStr ? parseInt(cleanStr, 10) : 0;
  }
}
